module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=EC - Ecuador.20eea1d0.svg";